module.exports = __webpack_public_path__ + "img/portugal-female.1a4c1da0.png";